import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot} from "@angular/router";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class RouteHelperService {

  /**
   * Constructs the full API URL based on the provided ActivatedRouteSnapshot.
   *
   * This method takes an ActivatedRouteSnapshot, which represents the state of the route
   * at a moment in time. It then constructs the full path of the route from the root to the
   * current route snapshot. This path is appended to the base API URL defined in the environment
   * configuration. The method is useful for generating API URLs dynamically based on the current
   * routing state in Angular applications.
   *
   * @param {ActivatedRouteSnapshot} route - The ActivatedRouteSnapshot instance representing
   *        the current routing state. It contains information about the active route's path segments.
   * @returns {string} The full API URL constructed by appending the full route path to the
   *          base API URL defined in `environment.apiUrl`.
   */
  public getApiUrlBasedOnActivatedRouteSnapshot(route: ActivatedRouteSnapshot): string {
    const fullPath = route.pathFromRoot
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .join('/');
    return `${environment.backendUrl}${fullPath}`;
  }
}
